exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr td[data-v-cc5dc042] {\n  background: #fff!important;\n}\n", ""]);

// exports
